import React from 'react';
import {IoWarning} from "react-icons/io5";
import {IoIosCloseCircle, IoMdCheckmarkCircle} from "react-icons/io";
import {Tooltip} from "antd";
import {TbQrcodeOff} from "react-icons/tb";

const PalletStatus = ({data}) => {
    const getIcon = () => {
        let icon;
        switch (data.palletStatusId) {
            case 1:
                icon = <IoWarning color='orange' size={20}/>
                break;
            case 2:
                icon = <IoMdCheckmarkCircle color='green' size={20}/>
                break;
            case 3:
                icon = <IoWarning color='red' size={20}/>
                break;
            case 4:
                icon = <IoMdCheckmarkCircle color='green' size={20}/>
                break;
            case 5:
                icon = <IoIosCloseCircle size={20} color='red'/>
                break;
            case 6:
                icon = <TbQrcodeOff size={20} color='red'/>
                break;
            default:
                icon = <IoWarning/>
                break;
        }
        return icon
    }
    return (
        <div><Tooltip title={data.palletStatus}>

            {getIcon()}
        </Tooltip>
        </div>
    );
};

export default PalletStatus;